'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CfgManager = require('./config');
var ErrManager = require('./error/manager');
var PageManager = require('./page/index');
var ResManager = require('./resource/manager');
var MetricManager = require('./metric/index');
var PvManager = require('./pv/index');
var LogManager = require('./log/manager');

var Dimns = require('./dimns');
var Util = require('./util/index');
var util = require('./util/util');
var configFilter = require('./util/filter');
var Logger = require('./util/logger');
var guid = require('./util/pageid');
var Extend = require('./util/extend');
var Logan = require('./util/logan');
var Event = require('./util/event');

var category = require('./constant/category');
var version = require('./constant/version').version;
var EM = require('./error/model');

var catchPage = require('./page/catch');
var catchError = require('./error/catch');
var catchResource = require('./resource/catch');

var OWL = function () {
    function OWL(config, opts) {
        _classCallCheck(this, OWL);

        var cfgManager = new CfgManager(config);
        this.errManager = new ErrManager(cfgManager);
        this.pageManager = new PageManager(cfgManager, this.errManager);
        this.resManager = new ResManager(cfgManager, this.errManager);
        this.metricManager = new MetricManager(cfgManager);
        this.pvManager = new PvManager(cfgManager);
        this.logManager = new LogManager(cfgManager);
        this.cfgManager = cfgManager;
        this.cfgManager.setExtension(Dimns.getExt());

        // 待配置 devMode 后再做 configFilter
        if (!(opts && opts.noFilter)) {
            configFilter(this.cfgManager);
        }
    }

    _createClass(OWL, [{
        key: 'config',
        value: function config(_config) {
            this.cfgManager.set(_config);
        }
    }, {
        key: 'getConfig',
        value: function getConfig(key) {
            return this.cfgManager.get(key);
        }
    }, {
        key: 'debug',
        value: function debug() {
            this.cfgManager.set({ devMode: true });
            Logger.setDebug();
        }
        /**
         *  上报自定义异常
         *  @param {any} err - 异常信息
         *  @param {Object} opts
         *  @param {Boolean} opts.combo - 是否合并请求
         *  @param {string} opts.category - 异常分类
         *  @param {string} opts.level - 异常级别
         *  @param {Object} opts.tags - 其他自定义信息
         */

    }, {
        key: 'addError',
        value: function addError(err, opts) {
            // 基于不同的参数条件，使用不同的方法
            var name = opts && opts.combo || this.getConfig('error').combo ? 'push' : 'report';
            this.errManager[name](err, opts);
        }
    }, {
        key: 'sendErrors',
        value: function sendErrors() {
            this.errManager.report();
        }
        /**
         *  上报自定义性能指标
         *  @param {Object} point - 性能指标信息
         *  @param {Number} point.position - 指标点位置
         *  @param {Number} point.duration - 耗时
         *  @param {Number} point.timeStamp - 时间戳
         */

    }, {
        key: 'addPoint',
        value: function addPoint(point) {
            if (!point || point.position === undefined) return;

            var newPoint = void 0;
            if (point.duration !== undefined) {
                newPoint = point;
            } else {
                var timing = Util.getPerfTiming();
                var navStart = timing && timing.navigationStart;
                if (typeof navStart == 'number') {
                    newPoint = {
                        position: point.position,
                        duration: (point.timeStamp || +new Date()) - navStart
                    };
                }
            }
            if (newPoint) {
                newPoint.ctags = util.isFlatObj(point.ctags) ? point.ctags : this.cfgManager.getCustomTags();
                this.pageManager.setUserReady();
                this.pageManager.push(newPoint);
            }
        }
    }, {
        key: 'sendPoints',
        value: function sendPoints() {
            this.pageManager.report(true);
        }
        /**
         *  上报自定义请求信息
         *  @param {Object} api - 请求信息
         *  @param {string} api.name - 请求名称
         *  @param {Number} api.networkCode - 网络状态码
         *  @param {Number} api.statusCode - 业务状态码
         *  @param {Number} api.responseTime - 请求耗时
         *  @param {string} [api.content] - 异常堆栈
         */

    }, {
        key: 'addApi',
        value: function addApi(api) {
            var validTypes = ['undefined', 'number'];
            if (!api || validTypes.indexOf(_typeof(api.networkCode)) < 0 || validTypes.indexOf(_typeof(api.statusCode)) < 0) return Logger.log('参数对象属性类型错误');

            var networkCode = api.networkCode !== undefined ? api.networkCode : '';
            var statusCode = api.statusCode !== undefined ? api.statusCode : '';
            var newApi = {
                type: 'api',
                connectType: api.connectType || '',
                resourceUrl: api.name,
                statusCode: networkCode + '|' + statusCode,
                responsetime: api.responseTime && api.responseTime.toString() || '0',
                ctags: util.isFlatObj(api.ctags) ? api.ctags : this.cfgManager.getCustomTags()
            };
            if (api.content) {
                newApi.firstCategory = category.AJAX;
                newApi.secondCategory = api.secondCategory || api.name;
                newApi.logContent = api.content;
            }
            this.resManager.pushApi(newApi);
        }
    }, {
        key: 'reportApi',
        value: function reportApi() {
            this.addApi.apply(this, arguments);
        }
    }, {
        key: 'sendApis',
        value: function sendApis() {
            this.resManager.report();
        }
        // 记录Logan日志

    }, {
        key: 'addLog',
        value: function addLog() {
            Logan._log.apply(Logan, arguments);
        }
    }, {
        key: 'createLog',
        value: function createLog() {
            return new LogManager(this.cfgManager);
        }
        // 重置参数并重新上报pv

    }, {
        key: 'resetPv',
        value: function resetPv(opts) {
            var _this = this;

            opts = opts || {};
            var cfgManager = this.cfgManager;
            var from = cfgManager.get('pageUrl');
            var to = opts.pageUrl || Util.getPageUrl();
            // if (!to || to === from) return
            var project = opts.project || cfgManager.get('project');
            var configs = {
                project: project,
                pageUrl: to,
                pageId: opts.pageId || 'owl-' + guid(),
                ctags: util.isFlatObj(opts.ctags) ? opts.ctags : cfgManager.getCustomTags()
            };
            cfgManager.set(configs);

            if (opts.delay) {
                // 连续快速resetPv时，只上报一次
                this.resetPvTimer && clearTimeout(this.resetPvTimer);
                this.resetPvTimer = setTimeout(function () {
                    _this.pvManager.report(configs);
                    Logan._log('[Navigation]:' + JSON.stringify({ project: project, from: from, to: to }), 'owl', 'info', ['navi']);
                }, 200);
            } else {
                this.pvManager.report(configs);
                Logan._log('[Navigation]:' + JSON.stringify({ project: project, from: from, to: to }), 'owl', 'info', ['navi']);
            }
        }
    }, {
        key: 'reportPv',
        value: function reportPv(opts) {
            this.pvManager.report(opts);
        }
        // 创建新的自定义指标实例

    }, {
        key: 'newMetricInst',
        value: function newMetricInst() {
            return new MetricManager(this.cfgManager);
        }
        // 新增, 更新, 移除异常过滤方法

    }, {
        key: 'updateFilter',
        value: function updateFilter(key, fn) {
            if (fn) {
                this.cfgManager.addFilter(key, fn);
            } else {
                this.cfgManager.removeFilter(key);
            }
        }
    }, {
        key: 'removeFilter',
        value: function removeFilter(key) {
            this.cfgManager.removeFilter(key);
        }
        /**
         * 为函数提供try-catch封装, 避免异常被抛出的同时上报异常
         *
         * @param {Function} func - 需封装的函数
         * @param {Object} context - 函数执行的上下文
         * @param {Object} opts - 等同于addError的opts
         */

    }, {
        key: 'wrap',
        value: function wrap(func, context, opts) {
            if (typeof func !== 'function') return func;
            try {
                if (func.__owl_wrapped__) return func;
                if (func.__owl_wrapper__) return func.__owl_wrapper__;
            } catch (e) {
                return func;
            }

            var wrapped = function wrapped() {
                try {
                    return func.apply(context, arguments);
                } catch (e) {
                    Owl.addError(e, opts);
                }
            };
            for (var property in func) {
                if (func.prototype.hasOwnProperty(property)) {
                    wrapped[property] = func[property];
                }
            }
            wrapped.prototype = func.prototype;
            func.__owl_wrapper__ = wrapped;
            wrapped.__owl_wrapper__ = true;

            return wrapped;
        }
        // 设置维度信息,支持:region,operator,network,container,os,unionId,latlng
        // latlng用于设置位置信息,值为:'${lat},${lng}'格式,如:'121.426805,31.221485'

    }, {
        key: 'setDimension',
        value: function setDimension(obj) {
            this.cfgManager.setExtension(obj);
        }
    }, {
        key: 'getDimension',
        value: function getDimension(key) {
            this.cfgManager.getExtension(key);
        }
    }, {
        key: 'reportFST',
        value: function reportFST() {
            var pageCfg = this.cfgManager.get('page');
            if (pageCfg.sensoryIndex || pageCfg.manualReportFST) return;

            this.cfgManager.set({ page: { manualReportFST: true } });
            this.pageManager.manualReportFST();
        }
    }, {
        key: 'createInstance',
        value: function createInstance(config) {
            var instance = null;
            try {
                if (window.Owl && window.Owl.OWL && config && config.project) {
                    if (typeof config.devMode === 'undefined') {
                        config.devMode = window.Owl.cfgManager.get('devMode');
                    }
                    instance = new window.Owl.OWL(config);
                }
            } catch (e) {
                Util.reportSysError(e);
            }
            return instance;
        }
    }, {
        key: 'getResTimingInfo',
        value: function getResTimingInfo(url) {
            if (!(window.performance && typeof window.performance.getEntriesByName === 'function')) return null;
            try {
                if (typeof url === 'string') {
                    var temp = window.performance.getEntriesByName(url, 'resource');
                    if (temp instanceof Array && temp.length && temp[0]) {
                        var duration = parseInt(Math.round(temp[0].duration));
                        return isNaN(duration) ? null : { name: url, duration: duration };
                    }
                } else if (url instanceof Array) {
                    var result = [];
                    for (var i = 0; i < url.length; i++) {
                        if (typeof url[i] === 'string') {
                            var info = this.getResTimingInfo(url[i]);
                            result.push(info ? info : null);
                        } else {
                            result.push(null);
                        }
                    }
                    return result;
                }
            } catch (e) {
                Util.reportSysError(e);
            }
            return null;
        }
    }, {
        key: 'SDKMetrics',
        value: function SDKMetrics(config) {
            try {
                if (!(config && config.project)) return;

                var instance = this.createInstance({
                    project: config.project,
                    devMode: config.devMode,
                    metric: { combo: false }
                });
                if (!(instance && instance.metricManager)) return;

                var metricManager = instance.metricManager;
                var tags = {
                    project: config.userProject || '',
                    version: config.version || ''
                };
                if (_typeof(config.tags) === 'object') {
                    tags = Extend(tags, config.tags);
                }
                metricManager.setTags(tags);
                metricManager.setExtraData(config.version || '');

                var random = Math.random();
                var pvConf = Extend({ auto: true, sample: 0.01 }, config.pv);
                if (pvConf.auto && random < pvConf.sample) {
                    metricManager.setMetric('sdkPV', 1);
                }

                var resConf = Extend({ auto: true, sample: 0.01 }, config.resource);
                if (config.url && resConf.auto && random < resConf.sample) {
                    var duration = void 0;
                    var info = this.getResTimingInfo(config.url);
                    if (info instanceof Array) {
                        for (var i = 0; i < info.length; i++) {
                            if (info[i] && typeof info[i].duration !== 'undefined') {
                                duration = info[i].duration;
                                break;
                            }
                        }
                    } else if (info && typeof info.duration !== 'undefined') {
                        duration = info.duration;
                    }
                    if (!isNaN(duration)) metricManager.setMetric('sdkCDNTiming', duration);
                }
                metricManager.report();
            } catch (e) {
                Util.reportSysError(e);
            }
        }
    }]);

    return OWL;
}();

var Owl = new OWL({}, { noFilter: true });
Owl.OWL = OWL;
// Important(2021-03-30): mws-sdk 内判断 window.Owl.__version__ < '1.8.10' 时会重新加载 owl_latest.js 文件
//   但这种判断方式不兼容 1.10.x 版本，导致版本为 1.10.x 时也会重新加载 owl 并覆盖此前的 window.Owl
//   已反馈 mws-sdk 同学修复，但因为有 mws-sdk 缓存，因此暂时强制写为 1.9.5，至少两周后的新版本才可改回正常逻辑
// Owl.__version__ = version
Owl.__version__ = '1.10.3';
Owl.errorModel = EM;
Owl.MetricManager = function () {
    var cfgManager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Owl.cfgManager;

    return new MetricManager(cfgManager);
};

Owl.start = function (configs) {
    if (Util.checkIsSpider()) return;
    if (window.Owl && window.Owl.isStarted) return;
    this.isStarted = true;

    var cfgManager = this.cfgManager;
    configs = configs || {};
    configs.pageUrl = configs.pageUrl || Util.getPageUrl();
    cfgManager.set(configs);

    var project = cfgManager.get('project');
    var loganCfg = cfgManager.get('logan');
    if (loganCfg && loganCfg.enable) {
        Logan.ready({
            LoganAPI: loganCfg.Logan,
            project: project,
            pageUrl: cfgManager.get('pageUrl'),
            loganConfig: loganCfg.config,
            version: loganCfg.version || '2.1.2'
        });
    }

    // 不同环境下设定特定过滤规则
    configFilter(cfgManager);

    // auto capture performance, error & resource
    catchPage(this.pageManager);
    catchError(this.errManager);
    catchResource(this.resManager);

    var captureCfg = cfgManager.get('autoCatch') || {};
    if (captureCfg.pv) {
        var ctags = cfgManager.getCustomTags();
        this.reportPv({ ctags: ctags }); // 自动上报一次pv
    }

    var spaCfg = cfgManager.get('SPA') || {};
    if (spaCfg.autoPV || spaCfg.getFST) {
        // 自动监听路由变化
        Util.hackHistoryStateFuncs();

        // 路由变化的回调
        var that = this;
        Event.on('validStateChange', function (pathInfo) {
            try {
                if (spaCfg.autoPV) {
                    var _ctags = cfgManager.getCustomTags();
                    that.resetPv({ delay: true, ctags: _ctags });
                }

                // 页面加载完成后再进行路由页面的首屏监听计算以提升准确性
                if (spaCfg.getFST && document.readyState == 'complete') {
                    var path = pathInfo.path;
                    var prevPath = that.prevRoutePath;
                    that.prevRoutePath = path;
                    that.pageManager.getRouteFst(path, prevPath);
                }
            } catch (e) {
                Util.reportSysWarn(e);
            }
        });
    }

    var handleApiCall = function handleApiCall(args) {
        try {
            if (args && args.length) {
                var name = args[0]; // api name
                if (!name || typeof name != 'string') return Logger.warn('Api名称不是有效字符串');
                if (name == 'start') return Logger.warn('start方法不可重复执行');
                if (typeof Owl[name] != 'function') return Logger.warn(name + '\u4E0D\u662F\u6709\u6548\u7684Api');

                try {
                    var params = args.slice(1); // api params
                    return Owl[name].apply(Owl, params);
                } catch (e) {
                    Logger.warn(name + ' Api\u6267\u884C\u62A5\u9519');
                    Logger.warn(e);
                    Util.reportSysWarn(e);
                }
            } else {
                Logger.warn('Api调用未传入有效参数');
            }
        } catch (e) {
            Util.reportSysWarn(e);
        }
    };
    var queue = window.owl && window.owl.q;
    if (queue && queue.length) {
        for (var i = 0; i < queue.length; i++) {
            handleApiCall(queue[i]);
        }
    }
    window.owl = function () {
        var args = [].slice.call(arguments);
        return handleApiCall(args);
    };

    var preLoadName = '_Owl_';
    if (window[preLoadName]) {
        window[preLoadName].isReady = true;

        var _window$preLoadName = window[preLoadName],
            preTasks = _window$preLoadName.preTasks,
            dataSet = _window$preLoadName.dataSet;

        if (preTasks && preTasks.length) {
            // sync execute api tasks
            preTasks.forEach(function (task) {
                Owl[task.api] && Owl[task.api].apply(Owl, task.data);
            });
            window[preLoadName].preTasks = [];
        }

        setTimeout(function () {
            // async report pre-catch data
            if (dataSet && dataSet.length) {
                dataSet.forEach(function (item) {
                    try {
                        if (item.type === 'jsError' && captureCfg.js) {
                            var name = item.data && item.data[0].type === 'unhandledrejection' ? 'parsePromiseUnhandled' : 'parseWindowError';
                            Owl.errManager[name].apply(Owl.errManager, item.data);
                        } else if (item.type === 'resError' && captureCfg.resource) {
                            Owl.resManager.handleResourceLoadError.apply(Owl.resManager, item.data);
                        } else if (item.type === 'resTime') {
                            Owl.resManager.handleResourceTiming.apply(Owl.resManager, item.data);
                        } else if (item.type === 'pageTime') {
                            Owl.pageManager.parsePageTime.apply(Owl.pageManager, item.data);
                        }
                    } catch (e) {}
                });
            }
            window[preLoadName].dataSet = [];
        }, 0);
    }

    this.errManager.checkCache();

    // report Owl version
    var versionReport = require('./version');
    versionReport('owl_sdk', Owl);

    // capture Owl self metrics
    var urlPrefix = Util.getProtocol() + '//www.dpfile.com/app/owl/static/owl_';
    this.SDKMetrics({
        project: 'owl',
        userProject: project,
        version: version,
        url: [urlPrefix + 'latest.js', urlPrefix + version + '.js']
    });
};

if (!(window.Owl instanceof OWL)) {
    window.Owl = Owl;
}

// 首先执行start方法，在start方法内处理其他的API调用
var queue = window.owl && window.owl.q;
if (queue && queue.length) {
    var item = queue[0];
    if (item && item[0] === 'start') {
        Owl.start(item[1]);
    }
}

module.exports = Owl;